import ExpanderList from './ExpanderList';

globalThis.ExpanderListComponents = {
  ExpanderList,
};
